import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { siteConfig } from "../../config/site";
import { useIsDanish } from "../../i18n/LanguageContext";

function ContactPage() {
  const isDa = useIsDanish();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonLoading(true);
    try {
      const response = await fetch("https://formspree.io/f/mwpvvwqw", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, phone, message }),
      });
      if (response.ok) {
        navigate("/success");
      } else {
        alert("Failed to submit form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit form (network error).");
    } finally {
      setButtonLoading(false);
    }
  };

  return (
    <>
      <style>{`
        .ct-section {
          position: relative;
          overflow: hidden;
          background:
            radial-gradient(ellipse 900px 600px at 5% 50%, rgba(37,99,235,0.10), transparent 65%),
            radial-gradient(ellipse 700px 500px at 95% 30%, rgba(124,58,237,0.10), transparent 65%),
            #f1f5f9;
          padding: 0 0 20px;
        }

        .ct-wrap {
          max-width: 1100px;
          margin: 0 auto;
          padding: 70px 24px 80px;
          font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
        }

        .ct-header {
          text-align: center;
          margin-bottom: 48px;
        }
        .ct-eyebrow {
          display: inline-block;
          color: #0978ee;
          font-size: 0.72rem;
          font-weight: 700;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          margin-bottom: 10px;
        }
        .ct-header h2 {
          margin: 0 0 12px;
          font-size: clamp(1.8rem, 3vw, 2.6rem);
          font-weight: 800;
          color: #0f1b4d;
          letter-spacing: -0.02em;
        }
        .ct-header p {
          color: #64748b;
          font-size: 1.05rem;
          max-width: 480px;
          margin: 0 auto;
          line-height: 1.65;
        }

        .ct-card {
          display: grid;
          grid-template-columns: 1fr 1.6fr;
          border-radius: 28px;
          overflow: hidden;
          box-shadow: 0 24px 64px rgba(2,6,23,0.10), 0 2px 12px rgba(2,6,23,0.06);
          border: 1px solid rgba(15,23,42,0.08);
        }
        @media (max-width: 860px) {
          .ct-card { grid-template-columns: 1fr; }
        }

        /* ── Trust strip ── */
        .ct-trust {
          display: flex;
          justify-content: center;
          gap: 16px;
          flex-wrap: wrap;
          margin: 36px auto 0;
          max-width: 1100px;
          padding: 0 24px;
        }
        .ct-trust-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px 20px;
          border-radius: 16px;
          background: white;
          border: 1px solid rgba(15,23,42,0.08);
          box-shadow: 0 2px 12px rgba(2,6,23,0.05);
          font-size: 0.9rem;
          color: #0f1b4d;
          font-weight: 600;
        }
        .ct-trust-icon {
          width: 36px; height: 36px;
          border-radius: 10px;
          background: linear-gradient(135deg, #2563eb, #7c3aed);
          display: grid;
          place-items: center;
          flex-shrink: 0;
        }
        .ct-trust-icon svg { color: white; }

        /* ── Left panel ── */
        .ct-info {
          padding: 40px 32px;
          background:
            radial-gradient(900px 500px at 0% 0%, rgba(59,130,246,0.35), transparent 55%),
            radial-gradient(700px 400px at 100% 100%, rgba(124,58,237,0.30), transparent 55%),
            linear-gradient(160deg, #0f1b4d, #1e3a8a);
          color: white;
          display: flex;
          flex-direction: column;
          gap: 32px;
        }

        .ct-info-heading h3 {
          margin: 0 0 8px;
          font-size: 1.5rem;
          font-weight: 800;
          letter-spacing: -0.02em;
        }
        .ct-info-heading p {
          margin: 0;
          color: rgba(255,255,255,0.72);
          font-size: 0.95rem;
          line-height: 1.6;
        }

        .ct-details {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }
        .ct-detail-item {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 14px;
          border-radius: 16px;
          background: rgba(255,255,255,0.08);
          border: 1px solid rgba(255,255,255,0.12);
        }
        .ct-detail-icon {
          width: 40px; height: 40px;
          border-radius: 12px;
          background: rgba(255,255,255,0.12);
          border: 1px solid rgba(255,255,255,0.18);
          display: grid;
          place-items: center;
          flex-shrink: 0;
        }
        .ct-detail-item strong {
          display: block;
          font-size: 0.8rem;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.55);
          margin-bottom: 2px;
        }
        .ct-detail-item span {
          font-size: 0.97rem;
          color: rgba(255,255,255,0.92);
        }

        .ct-promise {
          margin-top: auto;
          padding: 16px;
          border-radius: 18px;
          background: rgba(255,255,255,0.08);
          border: 1px solid rgba(255,255,255,0.12);
          font-size: 0.92rem;
          color: rgba(255,255,255,0.80);
          line-height: 1.6;
        }
        .ct-promise strong {
          display: block;
          color: white;
          font-size: 0.95rem;
          margin-bottom: 4px;
        }

        /* ── Right panel (form) ── */
        .ct-form-panel {
          padding: 40px 36px;
          background: white;
          display: flex;
          flex-direction: column;
          gap: 22px;
        }
        @media (max-width: 580px) {
          .ct-form-panel { padding: 28px 20px; }
          .ct-info { padding: 28px 20px; }
        }

        .ct-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }
        @media (max-width: 600px) {
          .ct-row { grid-template-columns: 1fr; }
        }

        .ct-field {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }
        .ct-field label {
          font-size: 0.82rem;
          font-weight: 700;
          color: #0f1b4d;
          letter-spacing: 0.04em;
          text-transform: uppercase;
        }
        .ct-field input,
        .ct-field textarea {
          padding: 12px 16px;
          border-radius: 12px;
          border: 1.5px solid rgba(15,23,42,0.12);
          font-size: 0.97rem;
          color: #0f1b4d;
          background: #f8fafc;
          outline: none;
          transition: border-color 0.15s, box-shadow 0.15s;
          font-family: inherit;
          resize: none;
        }
        .ct-field input:focus,
        .ct-field textarea:focus {
          border-color: #0978ee;
          box-shadow: 0 0 0 3px rgba(9,120,238,0.12);
          background: white;
        }
        .ct-field input::placeholder,
        .ct-field textarea::placeholder {
          color: #94a3b8;
        }

        .ct-submit {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          padding: 14px 32px;
          border-radius: 14px;
          border: none;
          cursor: pointer;
          font-size: 1rem;
          font-weight: 800;
          color: white;
          background: linear-gradient(135deg, #2563eb, #7c3aed);
          box-shadow: 0 14px 30px rgba(37,99,235,0.22);
          transition: transform 0.15s, box-shadow 0.15s, opacity 0.15s;
          align-self: flex-start;
        }
        .ct-submit:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 18px 40px rgba(37,99,235,0.28);
        }
        .ct-submit:disabled {
          opacity: 0.65;
          cursor: not-allowed;
        }
      `}</style>

      <div className="ct-section">
      <div className="ct-wrap">
        <div className="ct-header">
          <span className="ct-eyebrow">{isDa ? "Kontakt" : "Get in touch"}</span>
          <h2>{isDa ? "Lad os tale om jeres projekt" : "Let's talk about your project"}</h2>
          <p>{isDa ? "Fortæl hvad I arbejder på, så vender vi tilbage med en klar retning uden salgspres." : "Tell us what you're working on and we'll come back with a clear plan — no sales pitch, no pressure."}</p>
        </div>

        <div className="ct-card">
          {/* Left info panel */}
          <div className="ct-info">
            <div className="ct-info-heading">
              <h3>{isDa ? "Kontaktinformation" : "Contact information"}</h3>
              <p>{isDa ? "Vi svarer inden for én arbejdsdag." : "Our team responds within one business day."}</p>
            </div>

            <div className="ct-details">
              <div className="ct-detail-item">
                <div className="ct-detail-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.8 19.8 0 0 1 3.09 4.18 2 2 0 0 1 5.07 2h3a2 2 0 0 1 2 1.72 12.8 12.8 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 5.99 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.8 12.8 0 0 0 2.81.7A2 2 0 0 1 22 16.92Z" />
                  </svg>
                </div>
                <div>
                  <strong>{isDa ? "Telefon" : "Phone"}</strong>
                  <span>{siteConfig.phoneDisplay}</span>
                </div>
              </div>

              <div className="ct-detail-item">
                <div className="ct-detail-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2Z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </div>
                <div>
                  <strong>{isDa ? "E-mail" : "Email"}</strong>
                  <span>{siteConfig.email}</span>
                </div>
              </div>

              <div className="ct-detail-item">
                <div className="ct-detail-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12,6 12,12 16,14" />
                  </svg>
                </div>
                <div>
                  <strong>{isDa ? "Svartid" : "Response time"}</strong>
                  <span>{isDa ? "Inden for 1 arbejdsdag" : "Within 1 business day"}</span>
                </div>
              </div>
            </div>

            <div className="ct-promise">
              <strong>{isDa ? "Uforpligtende og uden salgspres." : "No obligation, no sales pressure."}</strong>
              {isDa ? "Vi lytter til hvad I har brug for, siger ærligt om vi kan hjælpe, og giver jer en klar retning." : "We'll listen to what you need, tell you honestly if we can help, and give you a clear plan — not a vague quote."}
            </div>
          </div>

          {/* Right form panel */}
          <form className="ct-form-panel" onSubmit={handleSubmit}>
            <div className="ct-row">
              <div className="ct-field">
                <label htmlFor="ct-name">{isDa ? "Navn" : "Name"}</label>
                <input id="ct-name" type="text" placeholder={isDa ? "Navn" : "Jane Smith"} value={name} onChange={e => setName(e.target.value)} required />
              </div>
              <div className="ct-field">
                <label htmlFor="ct-email">{isDa ? "E-mail" : "Email"}</label>
                <input id="ct-email" type="email" placeholder="jane@company.com" value={email} onChange={e => setEmail(e.target.value)} required />
              </div>
            </div>

            <div className="ct-field">
              <label htmlFor="ct-phone">{isDa ? "Telefon" : "Phone"} <span style={{fontWeight:400,textTransform:'none',letterSpacing:0,color:'#94a3b8'}}>({isDa ? "valgfri" : "optional"})</span></label>
              <input id="ct-phone" type="tel" placeholder={siteConfig.phoneDisplay} value={phone} onChange={e => setPhone(e.target.value)} />
            </div>

            <div className="ct-field">
              <label htmlFor="ct-message">{isDa ? "Besked" : "Message"}</label>
              <textarea id="ct-message" rows="5" placeholder={isDa ? "Fortæl hvad I bygger, forbinder eller prøver at løse..." : "Tell us what you're building or what problem you're trying to solve..."} value={message} onChange={e => setMessage(e.target.value)} required />
            </div>

            <button type="submit" className="ct-submit" disabled={buttonLoading}>
              {buttonLoading ? (isDa ? "Sender..." : "Sending\u2026") : (<>{isDa ? "Send besked" : "Send message"} <span aria-hidden="true">→</span></>)}
            </button>
          </form>
        </div>
      </div>

      {/* Trust strip below the card */}
      <div className="ct-trust">
        <div className="ct-trust-item">
          <div className="ct-trust-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/></svg>
          </div>
          {isDa ? "Cloud-, API- og governance-levering" : "Microsoft-first delivery"}
        </div>
        <div className="ct-trust-item">
          <div className="ct-trust-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12,6 12,12 16,14"/></svg>
          </div>
          {isDa ? "Svar inden for 1 arbejdsdag" : "Response within 1 business day"}
        </div>
        <div className="ct-trust-item">
          <div className="ct-trust-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="20,6 9,17 4,12"/></svg>
          </div>
          {isDa ? "Ingen lock-in, intet salgspres" : "No lock-in, no sales pressure"}
        </div>
        <div className="ct-trust-item">
          <div className="ct-trust-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="3" width="18" height="18" rx="4"/><path d="M8 12h8M12 8v8"/></svg>
          </div>
          {isDa ? "Tenant-aware og driftsklar levering" : "100% Azure-native delivery"}
        </div>
      </div>
      </div>
    </>
  );
}

export default ContactPage;
